import { render } from "./StatusSwitch.vue?vue&type=template&id=0c552750&scoped=true"
import script from "./StatusSwitch.vue?vue&type=script&lang=js"
export * from "./StatusSwitch.vue?vue&type=script&lang=js"

import "./StatusSwitch.vue?vue&type=style&index=0&id=0c552750&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c552750"]])

export default __exports__